/** leads/ProposalSettingsModal.tsx — 리드 포털 「경정청구 제안서」 하단 연락처·조직명 설정 (2026-09-10)
 *  담당 FP 연락처는 자동, 경정청구 팀장·벤처인증 팀장은 여기서. 제안서 모든 페이지 하단에 노출된다. */
import React, { useEffect, useState } from 'react';
import { getProposalSettings, saveProposalSettings } from './api';
import type { ProposalContact } from './types';

interface Props { onClose: () => void; onToast: (m: string, t?: string) => void }

export default function ProposalSettingsModal({ onClose, onToast }: Props) {
  const [org, setOrg] = useState('');
  const [contacts, setContacts] = useState<ProposalContact[]>([{ role: '경정청구 팀장', name: '', phone: '' }, { role: '벤처인증 팀장', name: '', phone: '' }]);
  const [busy, setBusy] = useState(false);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    getProposalSettings().then((s) => { setOrg(s.org || ''); if (s.contacts && s.contacts.length) setContacts(s.contacts); })
      .catch((e) => onToast((e as Error).message, 'error')).finally(() => setLoaded(true));
  }, [onToast]);
  const save = async () => {
    setBusy(true);
    try { await saveProposalSettings({ org: org.trim(), contacts }); onToast('제안서 연락처를 저장했습니다 — 담당자 포털의 제안서에 바로 반영됩니다'); onClose(); }
    catch (e) { onToast((e as Error).message, 'error'); } finally { setBusy(false); }
  };
  const upd = (i: number, k: keyof ProposalContact, v: string) => setContacts((cs) => cs.map((c, j) => (j === i ? { ...c, [k]: v } : c)));
  const inS: React.CSSProperties = { width: '100%', padding: '8px 10px', border: '1px solid #E5E7EB', borderRadius: 8, fontSize: 13, boxSizing: 'border-box', fontFamily: 'inherit' };
  return (
    <div className="ld-modal-bg" onClick={onClose}>
      <div className="ld-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-label="제안서 연락처 설정">
        <div className="ld-modal-h"><span>제안서 연락처 설정</span><button className="ld-btn" style={{ padding: '4px 10px' }} onClick={onClose}>닫기</button></div>
        <div className="ld-modal-b">
          <div style={{ fontSize: 12.5, color: '#4B5563', marginBottom: 14, lineHeight: 1.6 }}>
            담당자 포털의 관리 DB 카드에서 여는 <b>벤처투자소득공제 경정청구 제안서</b>(A4 2쪽) 하단에 연락처 3건이 실립니다.
            담당 FP·WM은 자동으로 들어가고, 아래 두 명은 여기서 정합니다. 비워 두면 그 칸은 표시되지 않습니다.
          </div>
          <div className="ld-field"><label>표기 조직명 (머리글 · 푸터)</label>
            <input style={inS} value={org} onChange={(e) => setOrg(e.target.value)} placeholder="비우면 담당자 소속(예: 한화생명금융서비스) 사용" /></div>
          {contacts.map((c, i) => (
            <div key={i} style={{ display: 'grid', gridTemplateColumns: '1.1fr 1fr 1.2fr', gap: 8, marginBottom: 8 }}>
              <div className="ld-field" style={{ marginBottom: 0 }}><label>역할</label><input style={inS} value={c.role} onChange={(e) => upd(i, 'role', e.target.value)} placeholder="경정청구 팀장" /></div>
              <div className="ld-field" style={{ marginBottom: 0 }}><label>이름</label><input style={inS} value={c.name} onChange={(e) => upd(i, 'name', e.target.value)} placeholder="홍길동" /></div>
              <div className="ld-field" style={{ marginBottom: 0 }}><label>연락처</label><input style={inS} value={c.phone} onChange={(e) => upd(i, 'phone', e.target.value)} placeholder="010-0000-0000" inputMode="tel" /></div>
            </div>
          ))}
          {contacts.length < 3 && <button className="ld-btn" style={{ padding: '5px 10px', fontSize: 12 }} onClick={() => setContacts((cs) => [...cs, { role: '', name: '', phone: '' }])}>+ 연락처 추가</button>}
        </div>
        <div className="ld-modal-f">
          <button className="ld-btn" onClick={onClose}>취소</button>
          <button className="ld-btn pri" disabled={busy || !loaded} onClick={save}>{busy ? '저장 중…' : '저장'}</button>
        </div>
      </div>
    </div>
  );
}
